import { render, staticRenderFns } from "./DataItem.vue?vue&type=template&id=ad3ef7de&scoped=true"
import script from "./DataItem.vue?vue&type=script&lang=js"
export * from "./DataItem.vue?vue&type=script&lang=js"
import style0 from "./DataItem.vue?vue&type=style&index=0&id=ad3ef7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3ef7de",
  null
  
)

export default component.exports